import React, { useContext, useState, useEffect } from "react";
import portuguese from "./portugueseLanguageData";
import english from "./englishLanguageData";

const LanguageContext = React.createContext();
const LanguageUpdateContext = React.createContext();
const EnglishContext = React.createContext();
const ExtraContext = React.createContext();
const ExtraUpdateContext = React.createContext();
const ActiveContext = React.createContext();
const AuthContext = React.createContext();
const AuthUpdateContext = React.createContext();

export function useLanguage() {
  return useContext(LanguageContext);
}

export function useLanguageUpdate() {
  return useContext(LanguageUpdateContext);
}

export function useEnglish() {
  return useContext(EnglishContext);
}

export function useExtra() {
  return useContext(ExtraContext);
}

export function useExtraUpdate() {
  return useContext(ExtraUpdateContext);
}

export function useActive() {
  return useContext(ActiveContext);
}

export function useAuth() {
  return useContext(AuthContext);
}

export function useAuthUpdate() {
  return useContext(AuthUpdateContext);
}

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(english);
  const [isEnglish, setEnglish] = useState(true);
  const [isActive, setActivate] = useState("none");
  const [extras, setExtras] = useState({
    title: "",
    text: "",
  });
  const activeLanguage = language;
  const ads = activeLanguage.facebookAdsCalculator;

  function handleExtrasLanguage(type) {
    let newTitle = "";
    let newText = "";
    switch (type) {
      case "Instructions":
        newTitle = activeLanguage.instructions;
        newText = ads.tooltips;
        break;
      case "Disclaimer":
        newTitle = "Disclaimer";
        newText = ads.disclaimer;
        break;
      default:
        return;
    }
    setExtras({ title: newTitle, text: newText });
  }

  function handleExtras(type) {
    let status = "";
    if (type !== isActive) {
      status = type;
    } else {
      status = "none";
    }
    setActivate(status);
    handleExtrasLanguage(type);
  }

  useEffect(() => {
    handleExtrasLanguage(isActive);
  }, [isEnglish]);

  // ACCESS FORM
  let initialAuth = "enter";
  const LOCAL_AUTHENTICATION = "Authenticate user";

  const isAuthenticated = JSON.parse(
    localStorage.getItem(LOCAL_AUTHENTICATION)
  );
  if (isAuthenticated) initialAuth = "auth";

  const [formState, setForm] = useState([
    activeLanguage.greeting,
    activeLanguage.get,
    activeLanguage.enter,
    initialAuth,
  ]);

  let text1 = "";
  let text2 = "";
  let text3 = "";
  let newState = "";
  let validateText = "";

  function updateText(newState) {
    switch (newState) {
      case "enter":
        text1 = activeLanguage.greeting;
        text2 = activeLanguage.get;
        text3 = activeLanguage.enter;
        break;
      case "get":
        text1 = activeLanguage.subscribe;
        text2 = activeLanguage.back;
        text3 = activeLanguage.mail;
        break;
      case "sent":
        text1 = activeLanguage.mailsent;
        text2 = activeLanguage.again;
        text3 = activeLanguage.enter;
        break;
      default:
        text1 = activeLanguage.greeting;
        text2 = activeLanguage.get;
        text3 = activeLanguage.enter;
        break;
    }
  }

  function authUpdate(action, code, checkbox) {
    if (action === "left") {
      switch (formState[3]) {
        case "enter":
          newState = "get";
          updateText(newState);
          break;
        case "get":
          newState = "enter";
          updateText(newState);
          break;
        case "sent":
          newState = "get";
          updateText(newState);
          break;
        default:
          newState = "enter";
      }
    } else if (action === "right") {
      switch (formState[3]) {
        case "enter":
          newState = "enter";
          authenticate(code);
          updateText(newState);
          break;
        case "get":
          newState = "sent";
          validateEmail(code, checkbox);
          updateText(newState);
          break;
        case "sent":
          newState = "sent";
          authenticate(code);
          updateText(newState);
          break;
        default:
          newState = "enter";
      }
    } else {
      newState = formState[3];
      updateText(newState);
    }
    setForm([text1, text2, text3, newState, validateText]);
  }

  useEffect(() => {
    if (formState[3] !== "auth") {
      authUpdate("refresh");
    }
  }, [isEnglish]);

  const accessCode = "MARKETINGPITA";

  function authenticate(code) {
    if (code.toUpperCase() === accessCode) {
      newState = "auth";
      localStorage.setItem(LOCAL_AUTHENTICATION, JSON.stringify(true));
    } else {
      validateText = activeLanguage.wrongCode;
    }
  }

  function validateEmail(code, checkbox) {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!regex.test(code.trim())) {
      validateText = activeLanguage.wrongEmail;
      newState = "get";
    }
    if (checkbox === false) {
      newState = "get";
      validateText += ` ${activeLanguage.notAgreed}`;
    }
  }
  // TOGGLE LANGUAGE

  function toggleLanguage() {
    let newLanguage = "";
    setEnglish((prevState) => !prevState);
    isEnglish ? (newLanguage = portuguese) : (newLanguage = english);
    setLanguage(newLanguage);
  }

  return (
    <LanguageContext.Provider value={language}>
      <LanguageUpdateContext.Provider value={toggleLanguage}>
        <EnglishContext.Provider value={isEnglish}>
          <ExtraContext.Provider value={extras}>
            <ExtraUpdateContext.Provider value={handleExtras}>
              <ActiveContext.Provider value={isActive}>
                <AuthContext.Provider value={formState}>
                  <AuthUpdateContext.Provider value={authUpdate}>
                    {children}
                  </AuthUpdateContext.Provider>
                </AuthContext.Provider>
              </ActiveContext.Provider>
            </ExtraUpdateContext.Provider>
          </ExtraContext.Provider>
        </EnglishContext.Provider>
      </LanguageUpdateContext.Provider>
    </LanguageContext.Provider>
  );
};
